const EventBus = window.VueEventBus
import { getNow } from '../../lib/dates'
import PageMixins from './pages'
import CartMixins from './location-checkout'
import DatesMixin from './dates'
import RacesMixin from './races'
import ProviderService from '../../services/provider'
import config from '../../lib/config'
import {parseNumber, getQS, alert, coerceBoolean} from '../../lib/utils'

let {DEFAULT_BOOKING_BUFFER: bookingBuffer = 30, TIMEZONE} = config

export default {
  mixins: [PageMixins, CartMixins, DatesMixin, RacesMixin],
  props: {
    item: {},
    items: {},
    groupedItems: {},
    cartView: {},
    columnClasses: {
      default: () => ({
        quantity: 'reservations-quantity',
        amount: 'reservations-amount',
        rate: 'reservations-rate'
      })
    },
    showItemRates: {
      default: false
    },
  },
  data() {
    return {
      itemInvalid: false,
      itemValidationError: null,
    }
  },
  created() {
    const item = this.item
    const itemId = item.id

    EventBus.$once('timer.timeout', (id) => {
      if (id === this.currentLocationId) {
        // EventBus.$off('timer.timeout')
        const autoRemoveItem = coerceBoolean(this.$$s('timer.expired.items.autoRemove', false))
        this.setTimeoutRemovedTypes([this.itemTypeTitle])
        this.setTimeoutRemovedItem(this)
        this.$nextTick(() => {
          this.showTimeoutAlert()
          this.$nextTick(() => {
            if(autoRemoveItem) {
              this.removeThisCartItem()
            }
          })
        })
      }
    })

    EventBus.$once('cart.error.item.expired.validation.' + this.item.id, (error, item, cart) => {
      EventBus.$emit('timer.timeout', this.currentLocationId)
      this.mayResetCountdownTimer()
    })

    if (this.reloadedCartTimedout) {
      EventBus.$emit('timer.timeout', this.currentLocationId)
      this.mayResetCountdownTimer()
    }

    EventBus.$on('cart-cleaned', cart => {
      this.unhold()
    })

    EventBus.$on(`cart.validate.before`, () => {
      this.itemInvalid = false
      this.itemValidationError = null
    })

    EventBus.$on(`cart.error.item.validation.${itemId}`, (e) => {
      this.itemInvalid = true
      this.itemValidationError = e.error[0]
    })

  },
  computed: {
    reloadedCartTimedout() {
      const holdEnds = 1 * _.get(this.item, 'payload.options.form.holdEndsAt', 0)
      const now = getNow().toSeconds()
      let expired = now > holdEnds
      if (!expired) {
        const earliestSlotTime = this.getEarliestSlotTime(this.item)
        if (earliestSlotTime) {
          expired = getNow(TIMEZONE, true)  >= (earliestSlotTime - (bookingBuffer * 60))
        }
      }
      return expired
    },
    itemOptions() {
      return _.get(this.item || {}, 'payload.options', {})
    },
    itemAttributes() {
      return _.get(this.item || {}, 'attributes', {})
    },
    itemSlot() {
      const options = this.itemOptions
      return options.slot || {}
    },
    itemForm() {
      const options = this.itemOptions
      return options.form || {}
    },
    itemRaceType() {
      const form = this.itemForm || {}
      return form.raceType || 'pro'
    },
    itemTypeTitle() {
      let title = this.itemForm.raceTitle
      if (title) {
        return title
      }
      const typeName = this.itemRaceType || 'pro'
      return ({
        ninja: 'Ninja Wipeout',
        pro: 'Race'
      })[typeName] || 'a Race'
    },
    usePackages() {
      return this.itemForm.usePackages
    },
    isNinja() {
      return this.itemRaceType === 'ninja'
    },
    ninjaHours() {
      const hour = this.itemForm.numberOfHours || 0
      return !hour ? '' : (hour + ' hour' + (hour > 1 ? 's': ''))
    },
    productRate() {
      return this.item.attributes.product.rate * (this.isNinja ? 2 : 1)
    },
    productCount() {
      return this.item.payload.count * (this.isNinja ? .5 : 1)
    },
    raceSettings() {
      return this.superchargedSettings.races[this.itemRaceType] || {}
    },
    itemTitle() {
      return this.item.title
    },

    slottedDate() {
      const form = this.itemForm || {}
      const date = form.selectedDate
      return date
    },
    slottedDateFormatted() {
      const date = this.slottedDate
      if (date) {
        return this.formatDate(date, 'M/d/y')
      }
      return ''
    },
    cartedSlots() {
      const form = this.itemForm || {}
      const slots = form.selectedSlots || {}
      return slots
    },
    childIds() {
      return this.itemOptions.childItems || []
    },
    racePointProductItems() {
      const childIds = this.childIds
      const races = _.reduce(childIds, (items, id) => {
        const item = this.cartItem(id)
        if (item && item.type === 'races') {
          items[id] = item
        }
        return items
      }, {})

      return races
    },
    racesTotalAmount() {
      let total = _.get(this.item, 'payload.options.total', 0)
      if (!total || total === 0 || total === '0') {
        total = this.itemOptions.tierTotal
      }
      return total
    },
    racesTotalTax() {
      return _.get(this.item, 'payload.options.tax', 0)
    },
    racesNetTotal() {
      return _.toFinite(this.racesTotalAmount) +
        _.toFinite(this.racesTotalTax)
    }

  },
  methods: {
    deleteFromOtherItems() {
      const items = this.items
      const item = this.item
      const itemId = _.get(item, 'attributes.slot.id')
      if (itemId) {
        const holds = []
        _.forOwn(items, otherItem => {
          if (otherItem.type === this.reservationType) {
            const {attributes: {form: {selectedSlots = {}}}} = otherItem
            let timeToDelete = null
            if (!_.isEmpty(selectedSlots)) {
              _.forOwn(selectedSlots, (slot, time) => {
                if (slot.id === itemId) {
                  timeToDelete = time
                  return false
                }
              })
              if (timeToDelete) {

                let thisSlot = selectedSlots[timeToDelete]
                let thisSlotHold = thisSlot.hold || {}
                let holdId = thisSlotHold.onlineBookingReservationsId
                if (holdId) {
                  holds.push(holdId)
                }
                delete selectedSlots[timeToDelete]
              }
            }
          }
        })
        if (holds.length) {
          ProviderService.unhold(holds)
        }
      }
    },
    removeThisCartItem(skipParent) {
      this.unhold()
      const item = this.item
      const items = _.cloneDeep(this.childIds)
      _.forOwn(items, id => {
        this.removeCartItem({id})
      })
      if (!skipParent) {
        this.removeCartItem({id: item.id})
        EventBus.$emit('cart-item-deleted', item, this, this.$parent)
        EventBus.$emit('cart-item-deleted-' + item.type, item, this, this. $parent)
      }
    },
    itemDelete($event) {
      // console.log({ITEM_DELETE: $event})
      const item = this.item
      this.unsetTimeoutRemovedItem(this)
      this.removeThisCartItem(true)
      const slots = this.cartedSlots

      this.deleteFromOtherItems()
      this.cartView.cartItemButtonClicked({
        $event,
        actionName: 'delete',
        id: item.id,
        item,
        cartItems: this.currentCartItems,
        button: {}
      })

      EventBus.$emit('cart-item-deleted', item, this, this.$parent)
      EventBus.$emit('cart-item-deleted-' + item.type, item, this, this.$parent)
    },
    itemEdit($event) {
      const item = this.item
      this.cartView.cartItemButtonClicked({
        $event,
        item,
        actionName: 'edit',
        id: this.item.id,
        cartItems: this.currentCartItems,
        button: {}
      })
      EventBus.$emit('cart-item-edit', item, this, this.$parent)
      EventBus.$emit('cart-item-edit-' + item.type, item, this, this.$parent)

      let routeName = item.editRoute || ('racewaybooking.' + (this.itemRaceType === 'ninja' ? 'ninja' : 'race'))
      if (_.isString(routeName)) {
        routeName = {name: routeName}
      }
      const route = Object.assign({}, routeName, {query: {item: item.id}})
      this.$router.push(route)
    },
    unhold() {
      const slots = this.cartedSlots
      const holds = _.reduce(slots, (items, slot, key) => {
        const holdId = _.get(slot, 'hold.onlineBookingReservationsId')
        if (holdId) {
          items.push(holdId)
        }
        return items
      }, [])
      if (holds.length) {
        ProviderService.unhold(holds)
      }
    }
  },
}
